export default "__VITE_ASSET__BgjOYQmQ__"